export default (function (_ref) {
  var request = _ref.request;
  return {
    marketPriceAdd: function marketPriceAdd(data) {
      return request({
        url: '/mng/marketPrice/add',
        method: 'post',
        data: data
      });
    },
    marketPriceModify: function marketPriceModify(data) {
      return request({
        url: "/mng/marketPrice/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    marketPriceDel: function marketPriceDel(id) {
      return request({
        url: "/mng/marketPrice/".concat(id, "/del"),
        method: 'delete'
      });
    },
    marketPriceQuery: function marketPriceQuery(data) {
      return request({
        url: '/mng/marketPrice/query',
        method: 'get',
        params: data
      });
    },
    marketPriceDetail: function marketPriceDetail(id) {
      return request({
        url: "/mng/marketPrice/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});